import $ from 'jquery';
import {disp_xhr_error} from './ui_tweak.js';
import { QueryString} from './base_ext.js';
import i18n from './i18n_js_with_locales';

function init_minimize_btn(){
    $('.btn-minimize').click(function(e){
	e.preventDefault();
	var $target = $('#talent-filter .box-content');
	var $btn = $(this);
	$target.slideToggle(function(){
	    var visible = $target.is(':visible');
	    $btn.find('.tl-filter-toggle-show').toggleClass('d-none', visible);
	    $btn.find('.tl-filter-toggle-hide').toggleClass('d-none', !visible);
	});
    });
}

function export_talent_csv(){
    $('#export-in-form').click();
}

function init_talent_delete_link(){
    $('a.talent-delete').on("ajax:success", function(event){
	const [data] = event.detail;
	if (data.errors && data.talent_id) {
	    if (data.errors.length > 0) {
		force_delete_talent(data.talent_id, data.errors[0]);
	    }
	    else {
		alert(i18n.t("flash.deleted_succ"));
		location.reload(true);
	    }
	}else {
	    alert(i18n.t("common.something_went_wrong"));
	}
    });
}

function force_delete_talent(talent_id, prompt_message){
    if (!talent_id) alert(i18n.t("common.something_went_wrong"));
    var retVal = confirm(prompt_message);

    if (retVal == true){
       $.ajax({url: '/talents/' + talent_id + '/force_delete',
               type: 'POST',
               dataType: 'json',
               success: function(data) {
		   if (data.msgs.length ==0 ) {
		       alert(i18n.t('flash.deleted_succ'));
		       location.reload(true);
		   }
		   else {
		       alert(data.msgs[0]);
		   }
	       },
       });
   }
}

function update_form_inputs(target_form, query_string){
    var qs = new QueryString(query_string);
    var keys = qs.keys()
    $(target_form + ' input').each(function(index, value){
	var node = $(this);
	var name_attr = node.attr("name");
	if (name_attr && name_attr.substring(0,2) == 'q['){
  	    if ($.inArray(name_attr, keys) >= 0)  node.val(qs.value(name_attr));
	    else node.val("");
	}
    });
    $(target_form + ' select').each(function(index, value){
	var node = $(this);
	var name_attr = node.attr("name");
	node.val([])
	if (name_attr && name_attr.substring(0,2) == 'q['){
	    if ($.inArray(name_attr, keys) >= 0)  node.val(qs.value(name_attr));
	}
    });
}

var FullTextOps = (function(){
    function init_checkbox_event(){
	$('#select-all-talents').click(function() {
	    $('#talent-result').find(':checkbox').prop('checked', this.checked);
	});
	$('#select-all-resumes').click(function() {
	    $('#resume-result').find(':checkbox').prop('checked', this.checked);
	});
    }

    function init_ops_buttons(){
	$('#btn-add-as-candidate').click(function(e){
	    if (fill_selected_talent_ids()) $('#candidate-for-job').modal('show');
	    e.preventDefault();
	});
	$('#btn-pool-dialog').click(function(e){
	    if (fill_selected_talent_ids()) $('#move-to-pool').modal('show');
	    e.preventDefault();
	});
    }

    function init_form_ajax(){
	$("#candidate-for-job form").on("ajax:success", function(event){
	    const [data] = event.detail;
	    alert(i18n.t("full_text.index.add_n_candidates", {nnn: data["affected"]}));
	    $('#candidate-for-job').modal('hide');
	}).on("ajax:error", function(event){
	    alert(i18n.t("common.something_went_wrong"));
	    $('#candidate-for-job').modal('hide');
	});

	$("#move-to-pool form").on("ajax:success", function(event){
	    const [data] = event.detail;
	    alert(i18n.t("full_text.index.process_n_candidates", {nnn: data["affected"]}));
	    $('#move-to-pool').modal('hide');
	}).on("ajax:error", function(event){
	    alert(i18n.t("common.something_went_wrong"));
	    $('#move-to-pool').modal('hide');
	});
    }

    function fill_selected_talent_ids(){
	var ids = [];
	$("input[name='talent_ids[]']:checked").each(function () {
	    ids.push($(this).val());
	});
	if (ids.length == 0) {
	    alert(i18n.t("common.no_records_selected"));
	    return false;
	}
	var uniq_ids = ids.filter(function(value, i){ return ids.indexOf(value) == i });
	$('input.target-talent-id-list').val(uniq_ids.join(','));
	return true;
    }

    return {
	init_checkbox_event: init_checkbox_event,
	init_ops_buttons: init_ops_buttons,
	init_form_ajax: init_form_ajax
    };
})();

function bind_event_for_ajax_add_talent_by_resume_uploading(){
    $('.create-by-uploading #new_talent_ajax').on("ajax:success", function(e){
	 const [data] = e.detail;
	 window.location.replace('/talents/'+data['talent_id']);
     }).on("ajax:error", function(e){
	 const [, , xhr] = e.detail;
	 disp_xhr_error(this, xhr );
     });
}

function init_talent_pool_select2(){
    $('select.pool-select2-field').select2({width: '100%'});
    $('select.flex-pool-id-q').select2({width: '100%',
					  allowClear: true,
					  placeholder: i18n.t("talents.index.select_talent_pool" )});
}

$( document ).ready(function() {
    update_form_inputs('#talent-filter', location.search);
    init_minimize_btn();
    init_talent_delete_link();
    init_talent_pool_select2();

    FullTextOps.init_checkbox_event();   //full_text  index.html.erb
    FullTextOps.init_ops_buttons();
    FullTextOps.init_form_ajax();

    bind_event_for_ajax_add_talent_by_resume_uploading();     //talent_upload new.html.erb

    $('#export_talent_csv').click(function(e){ export_talent_csv(); e.preventDefault(); });
});
